import { fixResponseJSON } from '../assets/helpers/funciones';
import { authInstance } from './axios';

const url = process.env.REACT_APP_API_URL;

export const potentialClientsService = {
  getPotentialClients: async (body) => {
    return await authInstance.post(`${url}/potentialClients/list`, body);
  },

  createPCBatch: async (file) => {
    const myInit = {
      method: 'POST',
      headers: {
        'x-api-key': process.env.REACT_APP_X_API_KEY,
        Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
      },
      body: file,
    };
    const response = await fetch(`${url}/potentialClients/create`, myInit);
    return fixResponseJSON(response);
  },

  updatePotentialClients: async (id, body) => {
    return await authInstance.put(`${url}/potentialClients/update/${id}`, body);
  },
};
